import script from "./logistics.vue?vue&type=script&setup=true&lang=js"
export * from "./logistics.vue?vue&type=script&setup=true&lang=js"

import "./logistics.vue?vue&type=style&index=0&id=d44215dc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d44215dc"]])

export default __exports__